import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export function ThemeToggle({ light = false }) {
  const { theme, toggle } = useTheme();
  const base = light
    ? "bg-white/15 text-white hover:bg-white/25"
    : "bg-surface-2 border border-border text-foreground hover:border-border-strong";
  return (
    <button
      data-testid="theme-toggle"
      onClick={toggle}
      aria-label="Toggle theme"
      className={`flex h-9 w-9 items-center justify-center rounded-lg transition-colors ${base}`}
    >
      {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
}
